import { type ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'quiet' | 'live' | 'ghost';

const VARIANT: Record<Variant, string> = {
  primary: 'bg-ink text-canvas hover:opacity-90',
  quiet: 'bg-surface-2 text-ink hover:bg-surface-3 border border-line',
  live: 'bg-live text-[#0b1a11] hover:brightness-110',
  ghost: 'text-ink-2 hover:text-ink hover:bg-surface-2',
};

export function Button({ variant = 'quiet', className = '', ...rest }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return (
    <button
      type="button"
      className={`inline-flex h-8 items-center gap-2 rounded-control px-3 text-body font-medium transition-colors disabled:opacity-50 ${VARIANT[variant]} ${className}`}
      {...rest}
    />
  );
}
